module.exports = __webpack_public_path__ + "static/media/logo127.40c3a941.png";